<template>
  <div class="container">
		<div v-if="this.language == 'de'">
			<p>Unsere Allgemeinen Gesch&auml;ftsbedingungen finden Sie hier zum Download:</p>
			<a href="/downloads/agb_schuett-biotec.pdf">Download</a>
		</div>
		<div v-if="this.language == 'en'">
			<p>Our terms of sale and delivery can be downloaded here:</p>
			<a href="/downloads/agb_schuett-biotec_E.pdf">Download</a>
    </div>
	</div>
</template>
<script>
  export default {
    name: 'agbs'
  }
</script>
<style>
	#container {
		margin: 1em;
		color: black;
	}
</style>




// WEBPACK FOOTER //
// src/components/agbs.vue